import React from "react"

const POSIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.49855 7.49808H5.4973C4.94487 7.49788 4.49709 7.05009 4.49689 6.49766V5.49724C4.49709 4.94481 4.94487 4.49702 5.4973 4.49683H8.49855C9.05099 4.49702 9.49877 4.94481 9.49897 5.49724V6.49766C9.49877 7.05009 9.05099 7.49788 8.49855 7.49808Z"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.99706 9.99915H10.9996C11.5521 9.99915 12 10.447 12 10.9996V14.501H3.99664V10.9996C3.99664 10.447 4.44454 9.99915 4.99706 9.99915Z"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99789 7.49817V9.99921"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0012 9.99915H18.0025C19.1062 10.0023 20.0001 10.8963 20.0033 12"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3946 7.4981C15.7275 7.50744 15.1087 7.15116 14.782 6.56953C14.2907 5.77778 14.4072 4.75228 15.0637 4.09098C15.7201 3.42968 16.7447 3.30559 17.5401 3.79105C18.3354 4.27652 18.6934 5.24454 18.4053 6.13069C18.1021 6.97393 17.2903 7.52598 16.3946 7.4981Z"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.99628 21.0038H21.0038V15.5015C21.0038 14.949 20.5559 14.5011 20.0034 14.5011H3.99669C3.44418 14.5011 2.99628 14.949 2.99628 15.5015V21.0038Z"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default POSIcon
